import React, { useEffect, useState } from "react";
import API from "../services/api";

function SupportPage() {
  const [errors, setErrors] = useState([]);

  const fetchErrors = async () => {
    const res = await API.get("/support/errors");
    setErrors(res.data);
  };

  const resolveError = async (id) => {
    await API.put(`/support/resolve/${id}`);
    fetchErrors();
  };

  useEffect(() => {
    fetchErrors();
  }, []);

  return (
    <div>
      <h2>Support Dashboard</h2>

      <table>
        <thead>
          <tr>
            <th>Message</th>
            <th>API</th>
            <th>Method</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {errors.map((err) => (
            <tr key={err.id}>
              <td>{err.message}</td>
              <td>{err.url}</td>
              <td>{err.method}</td>
              <td>{err.status}</td>
              <td>
                {err.status === "open" && (
                  <button onClick={() => resolveError(err.id)}>
                    Resolve
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SupportPage;